import firebase from 'firebase/compat/app';
import { useAtom } from 'jotai';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { NODE_ENV, REACT_APP_DEV_AUTO_LOGIN } from '../env';
import { currentAuthAtom } from '../jotai/atoms';

export function SessionManager({}) {
  const [currentAuth, setCurrentAuth] = useAtom(currentAuthAtom);

  // 認証状態を Subscribe する
  React.useEffect(() => {
    const auth = firebase.auth();

    // 開発環境でのみ自動ログインを試行
    const attemptDevinLogin = async (currentUser: firebase.User | null) => {
      if (
        NODE_ENV === 'development' &&
        REACT_APP_DEV_AUTO_LOGIN === 'true' &&
        !currentUser
      ) {
        try {
          await auth.signInWithEmailAndPassword(
            'devin-test@example.com',
            'DevinTest123!'
          );
          console.log('自動ログイン成功');
        } catch (error) {
          console.error('自動ログイン失敗', error);
        }
      }
    };

    return auth.onAuthStateChanged(user => {
      setCurrentAuth(user);
      attemptDevinLogin(user);
    });
  }, [setCurrentAuth]);

  // 認証状態のセッションがないことが確認されたら、トップにリダイレクトする
  if (currentAuth === null) {
    return <Redirect to="/" />;
  }

  return null;
}
